import { projectsAPI } from 'api';
import { call, put } from 'redux-saga/effects';
import { enableMarketingSuccess, enableMarketingFailed } from '../actions';

export default function* handleEnableMarketing({ payload }) {
  try {
    const data = yield call(projectsAPI.enableMarketing, {
      project: payload.id,
    });

    yield put(enableMarketingSuccess(data));
  } catch (e) {
    yield put(enableMarketingFailed(e));
  }
}
